import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import localeUtils from 'utils/LanguageLocale';
import framework from 'utils/framework';
import { wizardFormDataSelector } from 'selectors/taxClaim/wizardFormSelector';
import EN from 'components/RichProfile/MyAccount/TaxClaim/locales/TaxClaim_en_US.js';
import FR from 'components/RichProfile/MyAccount/TaxClaim/locales/TaxClaim_fr_CA.js';

const { wrapHOC } = framework;

const { getTextFromResource, getLocalisedDataFromResource } = localeUtils;
const getText = getLocalisedDataFromResource(EN, FR);

const fields = createSelector(
    wizardFormDataSelector,
    createStructuredSelector({
        taxExemptAddress: getTextFromResource(getText, 'taxExemptAddress'),
        taxExemptAddressSubtitle: getTextFromResource(getText, 'taxExemptAddressSubtitle'),
        existingAddressLabel: getTextFromResource(getText, 'existingAddressLabel'),
        addAddressLabel: getTextFromResource(getText, 'addAddressLabel'),
        taxExemptionMissingSelection: getTextFromResource(getText, 'taxExemptionMissingSelection'),
        taxExemptionInValidAddress: getTextFromResource(getText, 'invalidAddressSelection')
    }),
    (wizardFormData, textResources) => {
        const selectedCategory = wizardFormData.currentCategory;

        return {
            selectedCategory,
            ...textResources
        };
    }
);

const functions = {};

const withTaxAddressProps = wrapHOC(connect(fields, functions));

export {
    withTaxAddressProps, fields, functions
};
